import type { DeepPartial } from 'utility-types'
import { request } from '@remote/api/request'
import { IOptions, IParams } from '../type'

export function getPluginApp (space: string) {
  return request(
    'drive/v1/apps',
    {
      params: {
        space,
        location: location.href,
      },
      method: 'GET',
    },
  ) as Promise<DeepPartial<API_PLUGIN_MALL.GetPluginApp>>
}

export function getPluginStatus (space: string) {
  return request(
    'drive/v1/tasks',
    { 
      params: {
        space,
        limit: 50,
        type: 'user#app',
        filters:JSON.stringify({
          phase:{ in:'PHASE_TYPE_PENDING,PHASE_TYPE_RUNNING,PHASE_TYPE_ERROR,PHASE_TYPE_COMPLETE' },
          type:{ 'in':'user#app' },
        }),
      },
      method: 'GET',
    },
  ) as Promise<DeepPartial<API_PLUGIN_MALL.GetPluginStatus>>
}

export function deleteStatus (space: string, taskIds: string) {
  return request(
    'drive/v1/tasks',
    { method: 'DELETE', params: {
      space,
      task_ids: taskIds,
    } },
  ) as Promise<void>
}

export function actionPlugin (params: API_PLUGIN_MALL.ActionPluginRequest) {
  return request(
    'drive/v1/task',
    {
      data: params,
      method: 'POST',
    },
  ) as Promise<void>
}